import classNames from 'classnames';
import { PropsWithChildren, ReactElement } from 'react';

interface IProps extends PropsWithChildren {
  disabled?: boolean;
  active?: boolean;
  className?: string;
}

export const PaginationItem = ({ className, disabled, active, children }: IProps): ReactElement => (
  <div className={classNames('page-item', className, { disabled, active })}>{children}</div>
);
